// TODO: Dead Feature

export class PlayerRelatedVideos {
  constructor() {
    this.$recoNode    = $("#reco_gravity");

    this.videoId      = $("meta[data-type='Video']").data("id");
    this.videoTitle   = $("meta[property='og:title']").prop("content");

    this.fromRelated  = this.$recoNode.attr("data-from-related") === 'true';

    this.grParams     = this.fromRelated ? JSON.parse(this.$recoNode.attr("data-gr-params")) : undefined;
    this.platform     = window.VidioHelpers.isMobile() ? 'Mobile' : 'Desktop';
  }

  init() {
    if (this.$recoNode.length === 0) {
      return;
    }
    if (!this.fromRelated) {
      return;
    }

    var relatedRecommenderId = parseInt(this.grParams.recommender, 10);
    if (isNaN(relatedRecommenderId)) {
      relatedRecommenderId = 1;
    }

    var recommenderName = this.getRelatedRecommenderName(relatedRecommenderId);

    var gaTitle = recommenderName+"::CENTER::"+this.videoId+" - "+this.videoTitle;

    ga('kmkGATracker.send', 'event', this.platform, 'click', gaTitle);

    this.grParams.app_name = 'vidio';
    window.AhoyEvent.send('PLAYER RELATED::CLICK', this.grParams);
  }


  getRelatedRecommenderName(recommenderId) {
    if (recommenderId === 1) {
      return 'LATERAL';
    }
    else if (recommenderId === 2) {
      return 'LATERAL_EDITORIAL';
    }
    return 'LATERAL';
  }
}
